import { HasKind } from '@/utilities/HasKind';

export const kind = 'CleanComplete';

export type CleanComplete = HasKind<typeof kind>;

// Singleton-ish instance for convenience.
export const cleanComplete: CleanComplete = { kind };
